import type {
  ApiResponse,
  CreateTransactionFeeRequest,
  TransactionFee,
  UpdateTransactionFeeRequest
} from '../../types/ApiTypes';
import { apiManager } from '../api/ApiManager';

export class FeeService {
  async getTransactionFees(): Promise<ApiResponse<TransactionFee[]>> {
    return apiManager.get<TransactionFee[]>('/api/v1/admin/transaction-fees');
  }

  async createTransactionFee(data: CreateTransactionFeeRequest): Promise<ApiResponse<TransactionFee>> {
    return apiManager.post<TransactionFee>('/api/v1/admin/transaction-fees', data);
  }

  async updateTransactionFee(id: string, data: UpdateTransactionFeeRequest): Promise<ApiResponse<TransactionFee>> {
    return apiManager.put<TransactionFee>(`/api/v1/admin/transaction-fees/${id}`, data);
  }

  async deleteTransactionFee(id: string): Promise<ApiResponse> {
    return apiManager.delete(`/api/v1/admin/transaction-fees/${id}`);
  }
}

export const feeService = new FeeService();
